import _ from 'underscore';

import * as popup from 'Popup';
import * as net from 'util/Net';

export function checkPrimer(
  primerID: string | null,
  bases: string,
  saveCallback: () => void,
  filterId: string | null,
  failCallback: (res: Response) => void
): void {
  net
    .getJSON(`/1/api/sequences/${primerID}/check`, {bases})
    .done((res: Array<{id: string; name: string}>) => {
      const filteredSummaryDicts = res.filter((seq) => filterId !== seq.id);
      if (filteredSummaryDicts.length !== 0) {
        let msg: string;
        let names: string;
        const filtered = filteredSummaryDicts.map((seq) => `<b>${_.escape(seq.name)}</b>`);
        if (filtered.length > 2) {
          filtered[filtered.length - 2] = `${filtered[filtered.length - 2]}, and ${
            filtered[filtered.length - 1]
          }`;
          filtered.length -= 1;
          names = filtered.join(', ');
        } else {
          names = filtered.join(' and ');
        }
        // names is already properly escaped HTML and can be safely interpolated.
        if (filterId != null) {
          msg = `This primer is also attached to ${names}. Editing its bases may affect other binding sites.`;
        } else {
          msg = `This primer is attached to ${names}. Editing its bases may affect binding sites.`;
        }
        new popup.Confirm({
          title: 'Primer Edits',
          msg,
        })
          .choice('Save', 'btn-af-success', saveCallback)
          .choice('Cancel', 'btn-af-default')
          .show();
      } else {
        saveCallback();
      }
    })
    .fail(failCallback);
}
